import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React from "react";
import bgImage from "assets/images/license.png";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
const License = () => {
  const [t] = useTranslation("common");
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "left",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="left" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              <h2>{t("license.header")}</h2>
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="left"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <div>
                {t("license.text")}
                <h3>{t("termsofuse.rulesheader")}</h3>
                {t("termsofuse.rulestext")}
              </div>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default License;
